import { TreeRootsUpdated } from "event-definitions"

export async function waitForScheduleRefresh() {
    await TreeRootsUpdated.wait(3000)
}
